<!-- 记账单据打印 -->
<template>
    <div>
        <el-dialog :title="title" :visible.sync="dialogTableVisible" v-if="dialogTableVisible" width="1000px">
            <el-button :disabled="orderData.length == 0" type="primary" size="mini" style="margin-bottom:10px;" @click="showPrintPlan">批量打印</el-button>
            <el-table :row-class-name="tableRowClassName" :data="orderData" ref="multipleTable" border size="mini" style="width: 980px">
                <el-table-column prop="businessCode" label="单号" width="130">
                    <template slot-scope="scope">
                        <span v-if="isRift==1">
                            <a @click="toDetail(scope.row.businessCode)">{{scope.row.businessCode}}</a>
                        </span>
                        <span v-else>{{scope.row.businessCode}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="businessDate" label="记账日期" width="120">
                    <template slot-scope="scope">
                        {{ $common.getLocalTime(scope.row.businessDate) }}
                    </template>
                </el-table-column>
                <el-table-column prop="businessType" label="单据类型" v-if="fileType" min-width="100"></el-table-column>
                <el-table-column prop="opmName" label="业务员" min-width="150"></el-table-column>
                <el-table-column prop="unitName" label="单位" min-width="150"></el-table-column>
                <el-table-column prop="totalMoney" label="总金额" min-width="100"></el-table-column>
                <el-table-column prop="remark" label="备注" min-width="100"></el-table-column>
                <el-table-column label="操作" min-width="100">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="showPrint(scope.row.businessCode, scope.$index)" type="text">打印</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    name: "orderKeepPrint",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
    },
    data() {
        //这里存放数据
        return {
            dialogTableVisible: false,
            multipleSelection: [],
            orderData: [],
            fileIds: [],
            fileType: false,
            printSource: '',
            title: "记账单",
            isRift: 0,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "$store.state.selectobj": {
            handler: function (newValue, oldValue) {
                console.log(newValue, "测试");
                if (newValue != "") {
                    this.orderData.forEach(item => {
                        if (item.businessCode == newValue[0].rows[0].wobkemId) {
                            item.isSuccess = true
                        }
                    })
                }
            },
            deep: true,
        }
    },
    //方法集合
    methods: {
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({  //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: { isPenetrate } //参数
                }, '*');
            }
        },
        openBox(data, type) {
            console.log(type)
            this.title = "记账单"
            this.isRift = 0
            if (type == 1) {
                this.fileType = true
            } else if (type == "比例销售退补") {
                this.isRift = 1
                this.title = type
            }
            this.orderData = data
            this.dialogTableVisible = true
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        showPrintPlan() {
            const list = this.orderData.filter(item => {
                return !item.isSuccess
            })
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                var data = JSON.parse(sessionStorage.getItem("savePage"))
                if (window.global_config.bookkeepingShow) {
                    this.dialogTableVisible = false
                }
                if (data.jurId == JSON.parse(sessionStorage.getItem('printJurId'))) {
                    this.$refs.printPlan.openDia(list.map(item => item.businessCode), this.printSource, sessionStorage.getItem('printJurId'), '', 'all')
                } else {
                    this.$refs.printPlan.openDia(list.map(item => item.businessCode), this.printSource, data.jurId, '', 'all')
                }
                // 选中的数据//closeYl
            } else {
                return
            }
        },
        showPrint(id, index) {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                this.orderData[index].isSuccess = true
                this.orderData.splice(1, 0)
                this.$forceUpdate()
                if (window.global_config.bookkeepingShow && this.orderData.length == 1) {
                    this.dialogTableVisible = false
                }
                // 选中的数据
                this.$refs.printPlan.openDia(id, this.printSource, sessionStorage.getItem('printJurId'))
            } else {
                return
            }
        },
        tableRowClassName({ row, rowIndex }) {
            if (row.isSuccess) {
                return 'success-row';
            }
            return '';
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.printSource = sessionStorage.getItem('printSource').replace(/\"/g, "");
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style>
.el-table .success-row {
    background: #d0fab7 !important;
}
</style>
<style scoped>
::v-deep .el-table .el-table__body-wrapper {
    z-index: 1;
}
</style>